
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import clarity from '@microsoft/clarity';
import logger from '@/utils/logger';

/**
 * Composant pour suivre les navigations de page avec Microsoft Clarity
 */
const ClarityTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Tracker le changement de page avec la méthode event à la place de pageView
    try {
      if (clarity && typeof clarity.event === 'function') {
        clarity.event("page_view");
        logger.log(`Clarity page view tracked: ${location.pathname}`);
      }
    } catch (error) {
      logger.error('Erreur lors du tracking Clarity:', error);
    }
  }, [location]);

  return null; // Ce composant ne rend rien visuellement
};

export default ClarityTracker;
